import { FLOW_NODE_TYPE_MAP, OPPOSITE } from '../const'
import { t } from '@/init'

let flowKey

export default function flowElementsToNodeElements(flowElements, layout, key) {
  flowKey = key
  const listLayout = _handleLayoutList(layout)
  const taskNodes = []
  const gatewayNodes = []
  const eventNodes = []
  const edges = []

  flowElements.forEach((element) => {
    const type = FLOW_NODE_TYPE_MAP[element.$type]

    switch (type) {
      case 'edge':
        edges.push(getEdge(element))
        break
      case 'event':
        eventNodes.push(getEvent(element, listLayout))
        break
      case 'task':
        taskNodes.push(getTask(element, listLayout))
        break
      case 'callActivity':
      case 'serviceTask':
        taskNodes.push(getServiceTask(element, listLayout))
        break
      case 'subProcess':
        const node = getSubProcess(element, listLayout)
        const { graphInfo } = node
        taskNodes.push(node)
        // taskNodes.push(...graphInfo.taskNodes)
        // gatewayNodes.push(...graphInfo.gatewayNodes)
        // eventNodes.push(...graphInfo.eventNodes)
        edges.push(...graphInfo.edges)
        break
      case 'gateway':
        gatewayNodes.push(getGateway(element, listLayout))
        break
      default:
    }
  })

  return { taskNodes, gatewayNodes, eventNodes, edges }
}

function getEdge(element) {
  const { sourceRef, targetRef } = element

  const direction = element.waypoint
    ? getDirection(element.waypoint)
    : ['right', 'left']

  return {
    id: element.id,
    label: getI18nLabel(element),
    source: {
      cell: sourceRef.id,
    },
    target: {
      cell: targetRef.id,
    },
    startDirection: direction[0],
    endDirection: direction[direction.length - 1],
    data: {
      flowKey,
    },
  }

  // 获取连线的方向
  function getDirection(waypoint) {
    let direction = []
    for (let i = 0; i < waypoint.length - 1; i++) {
      const source = waypoint[i]
      const target = waypoint[i + 1]

      const isSameX = source.x === target.x
      const isSameY = source.y === target.y

      if (isSameX) {
        direction.push(source.y > target.y ? 'top' : 'bottom')
      }

      if (isSameY) {
        direction.push(source.x > target.x ? 'left' : 'right')
      }
    }

    direction.push(OPPOSITE[direction[direction.length - 1]])

    return direction
  }
}

function getEvent(element, listLayout) {
  const target = listLayout.find((item) => item.nodeId === element.id)

  const type = element.$type.replace('bpmn:', '')

  return {
    id: element.id,
    width: 60,
    height: 60,
    x: target.x,
    y: target.y,
    shape: 'Event',
    data: {
      label: getI18nLabel(element),
      type,
      flowKey,
    },
  }
}

function getTask(element, listLayout) {
  const target = listLayout.find((item) => item.nodeId === element.id)

  return {
    id: element.id,
    width: 60,
    height: 60,
    x: target.x,
    y: target.y,
    shape: 'Approver',
    data: {
      label: getI18nLabel(element),
      layout: target,
      flowKey,
      loopCharacteristics: element.loopCharacteristics,
    },
  }
}

function getGateway(element, listLayout) {
  const target = listLayout.find((item) => item.nodeId === element.id)
  return {
    id: element.id,
    width: 30,
    height: 30,
    x: target.x,
    y: target.y,
    shape: 'Gateway',
    data: {
      label: getI18nLabel(element),
      type: element.$type,
      flowKey,
    },
  }
}

function getServiceTask(element, listLayout) {
  const target = listLayout.find((item) => item.nodeId === element.id)
  return {
    id: element.id,
    width: 90,
    height: 60,
    x: target.x,
    y: target.y,
    shape: 'ServiceButton',
    data: {
      label: getI18nLabel(element),
      type: element.$type,
      flowKey,
    },
  }
}

function getSubProcess(element, listLayout) {
  const { bounds, flowElements } = element
  const graphInfo = flowElementsToNodeElements(flowElements, listLayout)

  return {
    id: element.id,
    width: bounds.width + 50,
    height: bounds.height,
    x: bounds.x - 80 <= 0 ? 0 : bounds.x - 80,
    y: bounds.y - 30 <= 0 ? 0 : bounds.y - 30,
    shape: 'SubProcess',
    graphInfo,
    data: {
      label: getI18nLabel(element),
      flowKey,
    },
  }
}

// 处理节点的位置
function _handleLayoutList(layout) {
  return layout.map((ele) => {
    if (ele.handled) return ele

    switch (ele.nodeType) {
      case 'START':
      case 'END':
        ele.x += getDeviation(30, 60)
        ele.y += getDeviation(30, 60)
        break
      case 'USERTASK':
      case 'SIGNTASK':
        ele.x += getDeviation(100, 60)
        ele.y += getDeviation(46, 60)
        break
      case 'CALLACTIVITY':
        ele.x += getDeviation(100, 90)
        ele.y += getDeviation(80, 60)
        break
      case 'SERVICETASK':
        ele.x += getDeviation(100, 90)
        ele.y += getDeviation(46, 60)
        break
      case 'PARALLELGATEWAY':
      case 'EXCLUSIVEGATEWAY':
      case 'INCLUSIVEGATEWAY':
        ele.x += getDeviation(50, 30)
        ele.y += getDeviation(50, 30)
        break
    }

    ele.handled = true

    return ele
  })

  function getDeviation(origin, current) {
    const halfOrigin = Math.ceil(origin / 2)
    const halfCurrent = Math.ceil(current / 2)

    return halfOrigin - halfCurrent + 20
  }
}

function getI18nLabel(node) {
  if (!node) return ''
  const { id, name } = node

  const i18nKey = `flow.${flowKey}.${id}.nodeName`

  const label = t(i18nKey)

  return label === i18nKey ? name || '' : label
}

let status

// 判断流程节点是否经过
export function judgeIsGoing(edge, opinions, flowStatus) {
  status = flowStatus

  return edgeIsGoing(edge, opinions)

  function edgeIsGoing(edge, opinions) {
    if (!opinions) return false
    const { sourceRef, targetRef } = edge

    let sourceNodeHasOpinion = judgeNodeHasOpinion(sourceRef, opinions)
    let targetNodeHasOpinion = judgeNodeHasOpinion(targetRef, opinions)

    return sourceNodeHasOpinion && targetNodeHasOpinion
  }

  // 判断节点是否有意见
  function judgeNodeHasOpinion(node, opinions) {
    const type = FLOW_NODE_TYPE_MAP[node.$type]
    let incoming, outgoing, flag
    switch (type) {
      case 'task':
        flag = opinions?.[node.id]?.hasOpinion
        return flag
      case 'event':
        if (node.$type === 'bpmn:StartEvent') {
          if (node.inSubProcess) return true
          return !!status
        } else {
          return status === 'end'
        }
      case 'gateway':
        incoming = node.incoming
          .map((item) => [item.sourceRef, item.targetRef])
          .flat()
          .filter((item) => item.id !== node.id)
        outgoing = node.outgoing
          .map((item) => [item.sourceRef, item.targetRef])
          .flat()
          .filter((item) => item.id !== node.id)
        return incoming.some((item) => judgeNodeHasOpinion(item, opinions))
      case 'callActivity':
      case 'subProcess':
        incoming = node.incoming
          .map((item) => [item.sourceRef, item.targetRef])
          .flat()
          .filter((item) => item.id !== node.id)
        flag = incoming.some((item) => judgeNodeHasOpinion(item, opinions))
        return flag
      default:
        return false
    }
  }
}
